// /**
//  * Orders - list
//  */

// React
import React from 'react';
import {Link} from 'react-router-dom';

// UI
import {Chip} from '@material-ui/core';

import {translate} from '../../../utils/helpers';
import jMoment from 'moment-jalaali';

// Type
import RonadIcons from '../../../components/iconComponent';
import SimpleTable, { TheadProps, TbodyProps } from '../../../components/Table/simpleTable';
import SimpleTableBody from '../../../components/Table/tableBody';
import SimpleTableHead from '../../../components/Table/tableHead';

type Props = {
  data: any;
  handleConfirmCanceleBox: (id: number) => void;
  changeStatusOrderWhitId: any;
  handleOpenConfirmUpdateState: any;
};

const statusMap = {
  FFC_FFC_SUPPORT_OPEN: 'نیازمند بررسی',
  FFC_SUPPORT_SUPPORT_OPEN: 'نیازمند بررسی',
  FFC_PARTNER_SUPPORT_OPEN: 'نیازمند بررسی',
  PARTNER_FFC_SUPPORT_OPEN: 'نیازمند بررسی',
  PARTNER_SUPPORT_SUPPORT_OPEN: 'نیازمند بررسی',
  PARTNER_PARTNER_SUPPORT_OPEN: 'نیازمند بررسی',
  FFC_FFC_SUPPORT_PENDING: 'نیازمند بررسی',
  FFC_SUPPORT_SUPPORT_PENDING: 'نیازمند بررسی',
  FFC_PARTNER_SUPPORT_PENDING: 'نیازمند بررسی',
  PARTNER_FFC_SUPPORT_PENDING: 'نیازمند بررسی',
  PARTNER_SUPPORT_SUPPORT_PENDING: 'نیازمند بررسی',
  PARTNER_PARTNER_SUPPORT_PENDING: 'نیازمند بررسی',
  FFC_FFC_SUPPORT_OWNER_ANSWERED: 'نیازمند بررسی',
  FFC_SUPPORT_SUPPORT_OWNER_ANSWERED: 'نیازمند بررسی',
  FFC_PARTNER_SUPPORT_OWNER_ANSWERED: 'نیازمند بررسی',
  PARTNER_FFC_SUPPORT_OWNER_ANSWERED: 'نیازمند بررسی',
  PARTNER_SUPPORT_SUPPORT_OWNER_ANSWERED: 'نیازمند بررسی',
  PARTNER_PARTNER_SUPPORT_OWNER_ANSWERED: 'نیازمند بررسی',
  SUPPORT_SUPPORT_SUPPORT_OPEN: 'نیازمند بررسی',
  SUPPORT_FFC_SUPPORT_OPEN: 'نیازمند بررسی',  
  SUPPORT_PARTNER_SUPPORT_OPEN: 'نیازمند بررسی',
  SUPPORT_SUPPORT_SUPPORT_PENDING: 'نیازمند بررسی',
  SUPPORT_FFC_SUPPORT_PENDING: 'نیازمند بررسی',
  SUPPORT_PARTNER_SUPPORT_PENDING: 'نیازمند بررسی',
  FFC_PARTNER_PARTNER_ASSIGNEE_ANSWERED: 'نیازمند بررسی',
  SUPPORT_PARTNER_FFC_ASSIGNEE_ANSWERED: 'نیازمند بررسی',
  SUPPORT_SUPPORT_PARTNER_ASSIGNEE_ANSWERED: 'نیازمند بررسی',
  SUPPORT_SUPPORT_FFC_ASSIGNEE_ANSWERED: 'نیازمند بررسی',
  SUPPORT_PARTNER_PARTNER_ASSIGNEE_ANSWERED: 'نیازمند بررسی',
  SUPPORT_FFC_FFC_ASSIGNEE_ANSWERED: 'نیازمند بررسی',
  SUPPORT_FFC_PARTNER_ASSIGNEE_ANSWERED: 'نیازمند بررسی',
  FFC_PARTNER_FFC_ASSIGNEE_ANSWERED : 'نیازمند بررسی',
  SUPPORT_PARTNER_FFC_OPEN : 'نیازمند بررسی',
  SUPPORT_PARTNER_FFC_OWNER_ANSWERED : 'نیازمند بررسی',
  SUPPORT_PARTNER_PARTNER_OPEN : 'نیازمند بررسی',
  SUPPORT_PARTNER_PARTNER_OWNER_ANSWERED : 'نیازمند بررسی',
  SUPPORT_PARTNER_SUPPORT_ASSIGNEE_ANSWERED : 'نیازمند بررسی',
  SUPPORT_PARTNER_SUPPORT_OWNER_ANSWERED : 'نیازمند بررسی',
  FFC_PARTNER_PARTNER_OPEN : 'نیازمند بررسی',
  FFC_PARTNER_PARTNER_OWNER_ANSWERED : 'نیازمند بررسی',
  FFC_PARTNER_SUPPORT_ASSIGNEE_ANSWERED : 'نیازمند بررسی',
  FFC_PARTNER_FFC_OPEN : 'نیازمند بررسی',
  FFC_PARTNER_FFC_OWNER_ANSWERED : 'نیازمند بررسی',
  FFC_SUPPORT_PARTNER_OPEN: 'نیازمند بررسی',
  SUPPORT_SUPPORT_SUPPORT_ASSIGNEE_ANSWERED : 'نیازمند بررسی',
  SUPPORT_SUPPORT_SUPPORT_OWNER_ANSWERED : 'نیازمند بررسی',
  PARTNER_PARTNER_PARTNER_OWNER_ANSWERED : 'نیازمند بررسی',
  PARTNER_PARTNER_FFC_OWNER_ANSWERED : 'نیازمند بررسی',
  PARTNER_FFC_FFC_ASSIGNEE_ANSWERED: 'در انتظار پاسخ مشتری',
  PARTNER_SUPPORT_SUPPORT_ASSIGNEE_ANSWERED: 'در انتظار پاسخ مشتری',
  PARTNER_FFC_SUPPORT_ASSIGNEE_ANSWERED: 'در انتظار پاسخ مشتری',
  PARTNER_SUPPORT_FFC_ASSIGNEE_ANSWERED: 'در انتظار پاسخ مشتری',
  FFC_FFC_PARTNER_OWNER_ANSWERED: 'در انتظار پاسخ مشتری',
  FFC_SUPPORT_PARTNER_OWNER_ANSWERED: 'در انتظار پاسخ مشتری',
  SUPPORT_FFC_PARTNER_OWNER_ANSWERED: 'در انتظار پاسخ مشتری',
  SUPPORT_SUPPORT_PARTNER_OWNER_ANSWERED: 'در انتظار پاسخ مشتری',
  PARTNER_PARTNER_PARTNER_PENDING: 'در انتظار پاسخ مشتری',
  PARTNER_FFC_PARTNER_PENDING: 'در انتظار پاسخ مشتری',
  PARTNER_SUPPORT_PARTNER_PENDING: 'در انتظار پاسخ مشتری',
  SUPPORT_PARTNER_PARTNER_PENDING: 'در انتظار پاسخ مشتری',
  SUPPORT_FFC_PARTNER_PENDING: 'در انتظار پاسخ مشتری',
  SUPPORT_SUPPORT_PARTNER_PENDING: 'در انتظار پاسخ مشتری',
  FFC_PARTNER_PARTNER_PENDING: 'در انتظار پاسخ مشتری',
  FFC_FFC_PARTNER_PENDING: 'در انتظار پاسخ مشتری',
  FFC_SUPPORT_PARTNER_PENDING: 'در انتظار پاسخ مشتری',
  PARTNER_SUPPORT_PARTNER_ASSIGNEE_ANSWERED: 'در انتظار پاسخ مشتری',
  PARTNER_PARTNER_PARTNER_CLOSED: 'بسته شده',
  PARTNER_PARTNER_SUPPORT_CLOSED: 'بسته شده',
  PARTNER_PARTNER_FFC_CLOSED: 'بسته شده',
  PARTNER_SUPPORT_PARTNER_CLOSED: 'بسته شده',
  PARTNER_SUPPORT_SUPPORT_CLOSED: 'بسته شده',
  PARTNER_SUPPORT_FFC_CLOSED: 'بسته شده',
  PARTNER_FFC_PARTNER_CLOSED: 'بسته شده',
  PARTNER_FFC_SUPPORT_CLOSED: 'بسته شده',
  PARTNER_FFC_FFC_CLOSED: 'بسته شده',
  SUPPORT_PARTNER_PARTNER_CLOSED: 'بسته شده',
  SUPPORT_PARTNER_SUPPORT_CLOSED: 'بسته شده',
  SUPPORT_PARTNER_FFC_CLOSED: 'بسته شده',
  SUPPORT_SUPPORT_PARTNER_CLOSED: 'بسته شده',
  SUPPORT_SUPPORT_SUPPORT_CLOSED: 'بسته شده',
  SUPPORT_SUPPORT_FFC_CLOSED: 'بسته شده',
  SUPPORT_FFC_PARTNER_CLOSED: 'بسته شده',
  SUPPORT_FFC_SUPPORT_CLOSED: 'بسته شده',
  SUPPORT_FFC_FFC_CLOSED: 'بسته شده',
  FFC_PARTNER_PARTNER_CLOSED: 'بسته شده',
  FFC_PARTNER_SUPPORT_CLOSED: 'بسته شده',
  FFC_PARTNER_FFC_CLOSED: 'بسته شده',
  FFC_SUPPORT_PARTNER_CLOSED: 'بسته شده',
  FFC_SUPPORT_SUPPORT_CLOSED: 'بسته شده',
  FFC_SUPPORT_FFC_CLOSED: 'بسته شده',
  FFC_FFC_PARTNER_CLOSED: 'بسته شده',
  FFC_FFC_SUPPORT_CLOSED: 'بسته شده',
  FFC_FFC_FFC_CLOSED: 'بسته شده',
  FFC_FFC_FFC_PENDING: 'در حال بررسی تیم',
  FFC_SUPPORT_FFC_PENDING: 'در حال بررسی تیم',
  FFC_PARTNER_FFC_PENDING: 'در حال بررسی تیم',
  SUPPORT_PARTNER_FFC_PENDING: 'در حال بررسی تیم',
  SUPPORT_SUPPORT_FFC_PENDING: 'در حال بررسی تیم',
  SUPPORT_FFC_FFC_PENDING: 'در حال بررسی تیم',
  PARTNER_SUPPORT_FFC_PENDING: 'در حال بررسی تیم',
  PARTNER_PARTNER_FFC_PENDING: 'در حال بررسی تیم',
  PARTNER_FFC_FFC_PENDING: 'در حال بررسی تیم',
  SUPPORT_SUPPORT_FFC_OWNER_ANSWERED : 'پاسخ به تیم',
  PARTNER_SUPPORT_FFC_OWNER_ANSWERED : 'پاسخ به تیم',
  FFC_SUPPORT_SUPPORT_ASSIGNEE_ANSWERED : 'پاسخ به تیم',
  FFC_SUPPORT_FFC_ASSIGNEE_ANSWERED : 'پاسخ به تیم',
  SUPPORT_SUPPORT_PARTNER_OPEN : 'ایجاد شده' ,
  SUPPORT_SUPPORT_FFC_OPEN : 'ایجاد شده' 
}


const ticketPriority = {
  LOW: {
    id: 0,
    name: 'LOW',
    title: 'کم',
    color: '#007644',
    bcolor: '#e8faea',
  },
  NORMAL: {
    id: 1,
    name: 'NORMAL',
    title: 'متوسط',
    color: '#FF7E07',
    bcolor: '#ffeedf',
  },
  HIGH: {
    id: 2,
    name: 'HIGH',
    title: 'زیاد',
    color: '#FF0000',
    bcolor: '#fffafa',
  },
  CRITICAL: {
    id: 3,
    name: 'CRITICAL',
    title: 'اضطراری',
    color: 'maroon',
    bcolor: '#fffafa',
  },
};

const headCells = [
  {
    id: 'tracking',
    label: 'شماره تیکت',
    align: 'center',
    format: row => (<>

      <RonadIcons
        name="circle"
        size="14px"
        fill={row.seen === '1' ? '#87FF93' : '#ec4040'}
        color='none'
      />
      &nbsp; &nbsp; &nbsp;
      <span>{row.tracking}</span>
      </>
    )
  },
  {
    id: 'linkId',
    label: 'شناسه',
    format: row => (
      <Link
        to={row.linkType === 'order' ? `/orders/${row.linkId}` : `/parcels/details/${row.linkId}`}
      >
        {row.linkId}
      </Link>
    )
  },
  {
    id: 'partner',
    label: 'پارتنر',
    align: 'center',
    format: row => (
      <span>{row?.partner?.names + ' - ' + row?.partner?.id }</span>
    )
  },
  {
    id: 'creatorId', 
    label: 'ایجاد کننده',
    format: row => (
      <span>{row?.creator?.username}</span>
    )
  },
  {
    id: 'assigneeId', 
    label: 'دردست',
    format: row => (
      <span> {row?.assignee?.username} ({row?.department?.name})</span>
    )
  },
  // {
  //   id: 'editorId', 
  //   label: 'آخرین ویرایش کننده',
  //   format: row => (
  //     <span>{ row?.editor?.username}</span>
  //   )
  // },
  {
    id: 'category', 
    label: 'دسته‌بندی',
    format: row => (
      <span>{row.category.name}</span>
    )
  },
  {
    id: 'subject', 
    label: 'موضوع',
    format: row => (
      <span>{row.subject && row.subject.body}</span>
    )
  },
  {
    id: 'title', 
    label: 'عنوان'
  },
  {
    id: 'status', 
    label: 'وضعیت',
    format: row => (
      <span>{statusMap[row.fullStatus]}</span>
    )
  },
  // {
  //   id: 'importance', 
  //   label: 'اولویت',
  //   format: row => (
  //     <Chip
  //       icon={
  //         <RonadIcons
  //           name="circle"
  //           size="14px"
  //           fill={ticketPriority[row.priority]?.color}
  //           color='none'
  //         />
  //       }
  //       // label={
  //       //   ticketPriority[row.priority]?.title
  //       // }
  //       style={{
  //         color: ticketPriority[row.priority]?.color,
  //         backgroundColor: ticketPriority[row.priority]?.bcolor,
  //         fontSize: '16px',
  //       }}
  //     />
  //   )
  // },
  {
    id: 'createdAt', 
    label: 'تایجاد',
    format: row => (
      <>
        <span>
          {`${jMoment(row.createdAt.split('T')[1], 'HH:mm:ss')
            .add(3, 'hours')
            .add(30, 'minutes')
            .locale('fa')
            .format('HH:mm')}
            `}
        </span>
        &nbsp;
        <span>
          {jMoment(row.createdAt, 'YYYY/M/D')
            .locale('fa')
            .format('jYY/jMM/jDD')}
        </span>
      </>
    )
  },
  {
    id: 'updatedAt', 
    label: 'بروزرسانی',
    format: row => (
      <>
        <span>
          {`${jMoment(row?.updatedAt?.split('T')[1], 'HH:mm:ss')
            .add(3, 'hours')
            .add(30, 'minutes')
            .locale('fa')
            .format('HH:mm')}
            `}
        </span>
        &nbsp;
        <span>
          {jMoment(row.updatedAt, 'YYYY/M/D')
            .locale('fa')
            .format('jYY/jMM/jDD')}
        </span>
      </>
    )
  },
];

const action = (row: any) => (<>
  <div>
    <Link to={`/ticketing/${row.id}`}>
      <RonadIcons className='mr-2 text-green' name='file-05' title="جزئیات سفارش"/>
    </Link>
  </div>
</>)

export default function EnhancedTable(props: Props) {

  return (
    <div>
      <SimpleTable
        defaultOrderBy="updatedAt"
        Thead={
          (prop: TheadProps) => (<SimpleTableHead
            headCells={headCells}
            action={action}
            {...prop}
          />)
        }
        Tbody={(prop: TbodyProps) => (<SimpleTableBody 
          celles={headCells}
          data={props.data}
          action={action}
          backgroundRow={row => row.assignmentType === 'FFC' ? '#ffeedf' : '#fff'}
          {...prop}
        />)}
      />
    </div>
  );
}
